// extracted by mini-css-extract-plugin
module.exports = {"teamSection":"team-section-module--teamSection--2GVf9","container":"team-section-module--container--3rpye"};